import { lumi } from '@/lib/lumi'

export interface InboxConversation {
  _id: string
  peerId: string
  storeName: string
  storeSlug: string
  avatarUrl: string
  lastMessage: string
  lastMessageAt: string
  lastSenderId: string
  unreadCount: number
}

export interface ChatMessage {
  _id: string
  conversationId: string
  senderId: string
  recipientId: string
  text: string
  read: boolean
  createdAt: string
}

export interface MessagePeer {
  userId: string
  storeName: string
  storeSlug: string
  avatarUrl: string
}

export interface ThreadPayload {
  conversation: { _id: string; unreadCount: number } | null
  peer: MessagePeer
  messages: ChatMessage[]
}

export function messagesError(error: unknown) {
  const err = error as { data?: { error?: string }; message?: string }
  return err?.data?.error || err?.message || 'Could not update messages. Try again.'
}

export async function invokeMessages<T>(body: Record<string, unknown>) {
  const result = await lumi.functions.invoke('messages', {
    method: 'POST',
    body,
  })
  const payload = result as T & { error?: string }
  if (payload && typeof payload === 'object' && 'error' in payload && payload.error) {
    throw new Error(payload.error)
  }
  return payload as T
}

export function messageThreadPath(peerId: string) {
  return `/messages/${encodeURIComponent(peerId)}`
}
